function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Login---Complete-State",
  transform: "translate(-257.000000, -156.000000)",
  fill: "#46B083",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  transform: "translate(250.000000, 126.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "EZ-Turn",
  transform: "translate(7.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "EZ_turn_long"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,72.9473684 L28.0782582,72.9473684 L40.4092438,57.1014282 L41.850258,55.4413349 L16.6302834,55.5156452 L16.6302834,45.2712196 L48.2064515,45.3618783 L61.4516129,28.3849345 L34.4299995,28.3849345 C23.3752984,28.3849345 12.6426365,28.3477793 1.58645127,28.3849345 C0.961665503,28.3849345 0,28.3849345 0,28.3849345 L0,31.0378142 C0,33.5732835 0,36.4594977 0,38.994967 L0,72.9473684 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127,63.119068 L108.665617,49.5805243 L108.665617,54.4532039 L78.0177105,54.4532039 L100.836818,23.0925243 C104.286254,18.2033981 106.833247,14.5537476 107.378377,12.9524466 C107.944885,11.2868544 108.46711,9.56893204 108.46711,7.08100971 C108.46711,1.21106796 102.472208,0.149514563 100.933018,0 L62.7113176,0.282582524 C62.5372425,0.282582524 62.3570596,0.266135922 62.1784035,0.266135922 L9.95587404,0.266135922 C7.74379692,0.266135922 5.92669721,0.584601942 4.50457491,1.22153398 C3.11720595,1.82815774 2.00398667,2.91019688 1.37427709,4.26415534 C0.710043164,5.65763107 0,7.55347573 0,9.74984466 L0,18.2886214 L2.18204663,18.2886214 C4.36256628,18.2886214 6.47742603,18.2781553 8.72360558,18.2886214 C18.0656359,18.315534 38.630929,18.2886214 47.9668514,18.2886214 L83.9408448,18.2886214 L60.3857354,49.3577476 L43.0606822,72.1916117 L108.46711,72.1916117 L108.46711,77 L127,63.119068 Z",
  id: "Path"
}))))));
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "127px",
    height: "77px",
    viewBox: "0 0 127 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2FF7BE7C-BEE5-4AFC-AA94-7697B0BE09FC@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b5b6c42af44a7af32418a568306ebf0b.svg";
export { ForwardRef as ReactComponent };